'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'engine';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e16e';
var svgPathData = 'M400 56c0 13.3-10.7 24-24 24l-64 0 0 48 96 0c39.8 0 72 32.2 72 72l0 176c0 39.8-32.2 72-72 72l-144 0c-22.7 0-44-10.7-57.6-28.8L180 384 168 384c-39.8 0-72-32.2-72-72l0-32-48 0 0 80c0 13.3-10.7 24-24 24S0 373.3 0 360L0 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80 48 0 0-32c0-39.8 32.2-72 72-72l96 0 0-48-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l176 0c13.3 0 24 10.7 24 24zM552 160c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zM168 176c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24l24 0c7.6 0 14.7 3.6 19.2 9.6l33.6 44.8c4.5 6 11.6 9.6 19.2 9.6l144 0c13.3 0 24-10.7 24-24l0-176c0-13.3-10.7-24-24-24l-240 0zm176 96l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEngine = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;